module.exports = __webpack_public_path__ + "static/ekure-de588402bafa5c1f11e8594a3427d72d.jpg";